/* tslint:disable */

declare var Object: any;
export interface TtadondutyrequestdtlInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "destinationCode": string;
  "startdate": Date;
  "enddate": Date;
  ttadondutyrequest?: any[];
  ttadondutyrequestdtlatds?: any[];
  ttadondutyrequestdtlitems?: any[];
  rel_destination?: any;
}

export class Ttadondutyrequestdtl implements TtadondutyrequestdtlInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "destinationCode": string;
  "startdate": Date;
  "enddate": Date;
  ttadondutyrequest: any[];
  ttadondutyrequestdtlatds: any[];
  ttadondutyrequestdtlitems: any[];
  rel_destination: any;
  constructor(data?: TtadondutyrequestdtlInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadondutyrequestdtl`.
   */
  public static getModelName() {
    return "Ttadondutyrequestdtl";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadondutyrequestdtl for dynamic purposes.
  **/
  public static factory(data: TtadondutyrequestdtlInterface): Ttadondutyrequestdtl{
    return new Ttadondutyrequestdtl(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadondutyrequestdtl',
      plural: 'Ttadondutyrequestdtls',
      path: 'Ttadondutyrequestdtls',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "destinationNo": {
          name: 'destinationNo',
          type: 'number'
        },
        "destinationCode": {
          name: 'destinationCode',
          type: 'string'
        },
        "startdate": {
          name: 'startdate',
          type: 'Date'
        },
        "enddate": {
          name: 'enddate',
          type: 'Date'
        },
      },
      relations: {
        ttadondutyrequest: {
          name: 'ttadondutyrequest',
          type: 'any[]',
          model: ''
        },
        ttadondutyrequestdtlatds: {
          name: 'ttadondutyrequestdtlatds',
          type: 'any[]',
          model: ''
        },
        ttadondutyrequestdtlitems: {
          name: 'ttadondutyrequestdtlitems',
          type: 'any[]',
          model: ''
        },
        rel_destination: {
          name: 'rel_destination',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadondutyrequestdtl.ts